(function (upp) {
    'use strict';

    upp.config(['$routeProvider',
        function ($routeProvider) {
            var resolver = {
                resolve : $routeProvider.ResolverFactory.moduleIsActivated("booking").resolver
            };

            $routeProvider
                .when('/booking/:calendarId?', {
                    templateUrl : require('../templates/booking.html'),
                    resolve : resolver
                })
                .when('/calendar/success', {
                    templateUrl : require('../templates/calendar-booking_success.html'),
                })
                .when('/account/bookings', {
                    templateUrl : require('../templates/calendar-my_bookings.html'),
                    resolve : resolver
                });
        }]);

})(upp);



// WEBPACK FOOTER //
// ./src/app/modules/booking/routes/booking-routes.js